import {ExperimentsBag} from '@wix/yoshi-flow-editor'
import {AnyAction} from 'redux'

const defaultState: ExperimentsBag = {}

export const experiments = (state = defaultState, action: AnyAction): ExperimentsBag => {
  switch (action.type) {
    default:
      return state
  }
}
